export const errors = {
  minLengthForStackTraceDetection: 250,
};
